import React from "react";

import Example from "./Example";
import Synonyms from "./Synonyms";

import "./Meaning.css";

export default function Meaning(props) {
  return (
    <section>
      <div className="Meaning">
        <h3>{props.meaning.partOfSpeech.toUpperCase()}</h3>
        {props.meaning.definitions.map(function (definition, idx) {
          return (
            <div key={idx}>
              <div>
                <ul>
                  <li>{definition.definition}</li>
                  <Example example={definition.example} />
                </ul>
              </div>
            </div>
          );
        })}
        <Synonyms synonyms={props.meaning.synonyms} />
      </div>
    </section>
  );
}
